import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodIdealIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="104"
        height="87"
        viewBox="0 0 104 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Ideal</title>
        <path
          d="M98.39 0.609375H5.87C3.18037 0.609375 1 2.78975 1 5.47937V80.9594C1 83.649 3.18037 85.8294 5.87 85.8294H98.39C101.08 85.8294 103.26 83.649 103.26 80.9594V5.47937C103.26 2.78975 101.08 0.609375 98.39 0.609375Z"
          stroke={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          strokeWidth="1.22"
        />
        <path
          d="M46.7794 40.9005C46.6094 40.7005 46.3894 40.5105 46.1094 40.4005C45.8294 40.2905 45.4994 40.2305 45.0894 40.2305H43.8994V44.9705H45.3594V44.9505C45.5994 44.9505 45.8194 44.9105 46.0594 44.8405C46.2794 44.7705 46.4894 44.6405 46.6494 44.4505C46.8194 44.2605 46.9594 44.0405 47.0794 43.7505C47.1894 43.4505 47.2494 43.1205 47.2494 42.6905C47.2494 42.3205 47.2094 41.9705 47.1394 41.6705C47.0694 41.3705 46.9394 41.1005 46.7694 40.8905L46.7794 40.9005Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
        <path
          d="M60.3989 40.6816L59.4189 43.4416H61.3589L60.4189 40.6816H60.3989Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
        <path
          d="M54.3589 26.2012H43.0389C41.7189 26.2012 40.6689 27.2712 40.6689 28.5712V60.0212H54.3589C66.7889 60.0212 72.1789 53.0012 72.1789 43.0712C72.1789 33.1412 66.7889 26.2012 54.3589 26.2012ZM48.7089 44.0412C48.5589 44.5012 48.3589 44.9112 48.0789 45.2412C47.7989 45.5712 47.4489 45.8312 47.0189 46.0412C46.5889 46.2312 46.0889 46.3412 45.5189 46.3412H42.2789V38.8212H45.4789V38.8412C45.9589 38.8412 46.4089 38.9112 46.8289 39.0612C47.2589 39.2112 47.6089 39.4512 47.9189 39.7512C48.2189 40.0612 48.4589 40.4512 48.6389 40.9012C48.8089 41.3612 48.8989 41.9012 48.8989 42.5312C48.8989 43.0912 48.8289 43.5912 48.6989 44.0512L48.7089 44.0412ZM55.6889 46.3412H49.9889V38.8212H55.5989V40.2312H51.6389V41.8412H55.2889V43.1212H51.6389V44.9512H55.6989V46.3412H55.6889ZM62.3589 46.3612L61.7889 44.6912H58.9689L58.3789 46.3612H56.7089L59.5389 38.8412H61.2589L64.0789 46.3612H62.3589ZM65.1189 46.3612V38.8412H66.7689V44.9712H70.4389V46.3612H65.1189Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
        <path
          d="M52.7894 21.5312H30.6694C28.7094 21.5312 27.1094 23.1212 27.1094 25.0912V61.1513C27.1094 63.1113 28.6994 64.7113 30.6694 64.7113H52.7794C68.3194 64.7113 76.8894 57.0213 76.8894 43.0813C76.8894 35.0413 73.7594 21.5413 52.7794 21.5413L52.7894 21.5312ZM52.7894 63.5212H30.6694C29.3494 63.5212 28.2994 62.4613 28.2994 61.1513V25.0912C28.2994 23.7712 29.3594 22.7212 30.6694 22.7212H52.7794C61.3394 22.7212 75.7094 25.3712 75.7094 43.0712C75.7094 56.2612 67.5594 63.5212 52.7794 63.5212H52.7894Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
        <path
          d="M34.4893 39.1309C32.5793 39.1309 31.0293 40.6809 31.0293 42.5909C31.0293 44.5009 32.5793 46.0509 34.4893 46.0509C36.3993 46.0509 37.9493 44.5009 37.9493 42.5909C37.9493 40.6809 36.3993 39.1309 34.4893 39.1309Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
        <path
          d="M34.4894 48.0508C33.0294 48.0508 31.8594 49.2408 31.8594 50.6808V54.7708C31.8594 57.6608 34.1894 60.0108 37.0994 60.0108H37.1194V50.6808C37.1194 49.2208 35.9294 48.0508 34.4894 48.0508Z"
          fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodIdealIcon;
